import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_WORKING_DOCS_LINK_INF_LIST_ID");
const SPPublishListId = getEnv("REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID");

const expand =
  "&expand=fields(select=Title, docUrl, docLinkUrl,docPublicDepartment, effectiveFrom, effectiveTo,docAreas, docId, docCode, docInfoLookupId, docFileId, docInfo_x003a_docId, docInfo_x003a_Title, docInfo_x003a_docStatusId, docInfo_x003a_docStatus, docInfo_x003a_docStatusValue, docLinkId, docLinkCode, docLinkInfo, docLinkInfoLookupId, docLinkFileId, docLinkTitle, docLinkInfo_x003a_docId, docLinkInfo_x003a_Title, docLinkInfo_x003a_docStatusId, docLinkInfo_x003a_docStatus, docLinkInfo_x003a_docStatusValue, docLinkInfo_x003a_docStatusValue, docLinkInfo_x003a_effectiveFrom, docLinkInfo_x003a_effectiveTo, Tags, docTypeId, docLinkTypeId, docLinkExpiredDate, isDeleted)";

export class DocumentLinkService {
  static async getListDocumentLinkInfos() {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${"expand=fields"}&$top=5000`))
      .then((res) => {
        const child = res.data.value.map((item: any) => this.mapData(item));
        return {
          data: child,
          count: child.length,
        };
      })
      .catch((err) => {
        console.error(err);
        return {
          data: [],
          count: 0,
        };
      });
  }

  static async getDocumentLinkInfos(docInfoId: any, listId: any = null) {
    if (!listId) {
      listId = SPListId;
    }

    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${listId}/items?${expand}&$top=5000&filter=fields/docId eq ${docInfoId}`))
      .then((res) => {
        const child = res.data.value.map((item: any) => this.mapData(item));
        return {
          data: child,
          count: child.length,
        };
      })
      .catch((err) => {
        console.error(err);
        return {
          data: [],
          count: 0,
        };
      });
  }

  static async getDocumentLinkedInfos(docLinkId: any, listId: any = null) {
    if (!listId) {
      listId = SPListId;
    }

    return api
      .get(
        getURL(`/sites/${SPSiteId}/lists/${listId}/items?${expand}&$top=5000&filter=fields/docLinkId eq ${docLinkId}`),
      )
      .then((res) => {
        const child = res.data.value.map((item: any) => this.mapData(item));
        return {
          data: child,
          count: child.length,
        };
      })
      .catch((err) => {
        console.error(err);
        return {
          data: [],
          count: 0,
        };
      });
  }

  static async getPublicDocumentInfoFromWorkingDocument(docWorkingId: any, listId: any = undefined) {
    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPPublishListId}/items?${expand}&$top=5000&filter=fields/docWorkingId eq ${docWorkingId}`,
        ),
      )
      .then((res) => {
        if (res && res.data.value.length > 0) return this.mapData(res.data.value[0]);
        return null;
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async createDocumentLinkInfo(fields: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), { fields })
      .then((res) => this.mapData(res.data))
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateDocumentLinkInfo(id: any, fields: any) {
    return api
      .patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async deletedDocumentLinkInfo(id: any, listId?: string) {
    if (!listId) listId = SPListId;

    return api
      .delete(getURL(`/sites/${SPSiteId}/lists/${listId}/items/${id}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static mapData(documentLinkItem: any) {
    return {
      id: documentLinkItem.id,
      Title: documentLinkItem.fields.Title,
      Tags: documentLinkItem.fields.Tags,
      docAreas: documentLinkItem.fields.docAreas,
      effectiveFrom: documentLinkItem.fields.effectiveFrom,
      effectiveTo: documentLinkItem.fields.effectiveTo,
      docId: documentLinkItem.fields.docId,
      docCode: documentLinkItem.fields.docCode,
      docTypeId: documentLinkItem.fields.docTypeId,
      docTitle: documentLinkItem.fields.docInfo_x003a_Title,
      docInfoId: documentLinkItem.fields.docInfoLookupId,
      docFileId: documentLinkItem.fields.docFileId,
      docUrl: documentLinkItem.fields.docUrl,
      docStatusId: parseInt(documentLinkItem.fields.docInfo_x003a_docStatusId),
      docStatus: documentLinkItem.fields.docInfo_x003a_docStatus,
      docEffectiveFrom: documentLinkItem.fields.docInfo_x003a_effectiveFrom,
      docEffectiveTo: documentLinkItem.fields.docInfo_x003a_effectiveTo,
      docPublicDepartment: documentLinkItem.fields.docPublicDepartment,
      docLinkId: documentLinkItem.fields.docLinkId,
      docLinkTitle: documentLinkItem.fields.docLinkTitle,
      docLinkCode: documentLinkItem.fields.docLinkCode,
      docLinkTypeId: documentLinkItem.fields.docLinkTypeId,
      docLinkIdId: documentLinkItem.fields.docLinkInfoLookupId,
      docLinkFileId: documentLinkItem.fields.docLinkFileId,
      docLinkUrl: documentLinkItem.fields.docLinkUrl,
      docLinkStatusId: parseInt(documentLinkItem.fields.docLinkInfo_x003a_docStatusId),
      docLinkStatus: documentLinkItem.fields.docLinkInfo_x003a_docStatus,
      docLinkEffectiveFrom: documentLinkItem.fields.docLinkInfo_x003a_effectiveFrom,
      docLinkEffectiveTo: documentLinkItem.fields.docLinkInfo_x003a_effectiveTo,
      docLinkExpiredDate: documentLinkItem.fields.docLinkExpiredDate,
      isDeleted: documentLinkItem.fields.isDeleted,
    };
  }
}
